import React from "react";
import styles from "./LocationDetails.module.css"
import {Section} from "../../../../../elements/section/Section";
import {FullLocationUi} from "../../../../../../api/generated";
import {TextFieldsLine} from "../../../../../elements/textFieldsLine/TextFieldsLine";
import {LocationAvailability} from "./LocationAvailability/LocationAvailability";

interface LocationDetailsProps {
    location: FullLocationUi
}

export const LocationDetails: React.FC<LocationDetailsProps> = ({
                                                                    location
                                                                }) => {
    return <Section title={"Location Details"}>
        <div className={styles.fieldsWrapper}>
            <TextFieldsLine
                leftFieldTitle={"Name"}
                leftFieldValue={location.name}
                rightFieldTitle={"Location ID"}
                rightFieldValue={location.publicId}
            />
            <TextFieldsLine
                leftFieldTitle={"Postcode"}
                leftFieldValue={location.postcode}
                rightFieldTitle={"Phone number"}
                rightFieldValue={location.phoneNumber}
            />
            <TextFieldsLine
                leftFieldTitle={"City"}
                leftFieldValue={location.city}
                rightFieldTitle={"Location Hash"}
                rightFieldValue={location.locationHash || "—"}
            />
            <LocationAvailability workSchedule={location.workSchedule}/>
        </div>
    </Section>
}
